var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whatsNew"},[_c('div',{staticClass:"whatsNew-title"},[_c('h1',[_c('router-link',{attrs:{"to":"/news"}},[_vm._v("\n        WHAT'S NEW\n      ")])],1)]),_c('div',{staticClass:"table-container"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.limitedList),function(ref){
var id = ref.id;
var name = ref.name;
var date = ref.date;
var tag = ref.tag;
return _c('tr',{key:id},[_c('th',[_vm._v(_vm._s(date))]),_c('td',[_c('span',{staticClass:"tag is-white"},[_vm._v("\n              "+_vm._s(tag)+"\n            ")])]),_c('td',[_c('p',[_vm._v("\n              "+_vm._s(name)+"\n            ")])])])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }